import React from 'react';
import Page from 'components/Page';
import { FormattedMessage } from 'react-intl';
import { Button, Upload } from 'antd';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { useMutation } from 'hooks/apollo';
import useGlobalContext from 'hooks/useGlobalContext';
import { gql } from '@apollo/client';
import SurveyTranslations from './SurveyTranslations';

import messages from '../messages';

const IMPORT_MUTATION = gql`
  mutation($file: Upload!) {
    importSurveyTranslations(file: $file)
  }
`;

const SurveyTranslationsPage = () => {
  const [mutate, { loading }] = useMutation(IMPORT_MUTATION, { refetchQueries: ['DefaultTranslations'] });
  const { message } = useGlobalContext();

  const upload = {
    name: 'file',
    action: `${process.env.MANAGER_BASE_PATH}/upload/surveyTranslations`,
    showUploadList: false,
    beforeUpload: async file => {
      const isXls = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

      if (!isXls) {
        message.error(`${file.name} is not an Excel file`);
      } else {
        try {
          const { data } = await mutate({ variables: { file } });
          message.success(`Imported ${data.importSurveyTranslations} translations successfully`);
        } catch (e) {
          message.error(`Something went wrong. ${e.message}`);
        }
      }

      return false;
    },
  };

  return (
    <Page>
      <Page.Header
        title={<FormattedMessage {...messages.surveyTranslations} />}
        extra={(
          <>
            <Button type="primary" href={`${process.env.MANAGER_BASE_PATH}/download/surveyTranslations.xlsx`}>
              <DownloadOutlined />
              <FormattedMessage {...messages.exportSurveyTranslations} />
            </Button>
            <Upload {...upload}>
              <Button type="primary" loading={loading}>
                <UploadOutlined />
                <FormattedMessage {...messages.importSurveyTranslations} />
              </Button>
            </Upload>
          </>
        )}
      />
      <Page.Content>
        <SurveyTranslations />
      </Page.Content>
    </Page>
  );
};

export default SurveyTranslationsPage;
